import {ProgramBookable} from "@/program/interfaces/ProgramBookable";

/** Duration applied when a booker states neither a duration nor a type. */
export const FALLBACK_DURATION = 15;

/**
 * Duration to send when booking through a program booker, or undefined to let
 * the appointment type decide.
 *
 * The type carries the duration; the booker only overrides it when it states
 * one of its own — its column being NOT NULL, zero is how it says it does not.
 * Sending a default would silently beat the type, the server resolving
 * `duration ?? type.duration`. A booker with neither still needs a duration,
 * hence the last resort.
 */
export const durationForBooker = (bookable?: ProgramBookable | null): number | undefined => {
    if (bookable?.appointment_duration) {
        return bookable.appointment_duration;
    }

    return bookable?.appointment_type_id ? undefined : FALLBACK_DURATION;
};
